<template lang="html">

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/internal-control')">Control Interno</li>
        <li class="breadcrumb-item active" aria-current="page">Verificación CURP</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="row" style="margin-top:20px;">
        <div class="col-md-6">
          <md-card>
            <md-card-header>
              <div class="md-title">EMAIL o UID del Usuario Nuevo</div>
            </md-card-header>
            <md-card-content>
              <div class="row">
                <div class="col-md-10">
                  <md-field>
                    <label>EMAIL/UID</label>
                    <md-input v-model="emailOrUID" v-on:keyup.enter="getInfo(1)"/>
                  </md-field>
                </div>
                <div class="col-md-2">
                  <md-progress-spinner v-if="loading1" :md-diameter="30" :md-stroke="3" md-mode="indeterminate"/>
                  <md-button v-else class="md-raised md-primary" @click="getInfo(1)" :disabled="emailOrUID===null">
                    Buscar
                  </md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <div class="col-md-6">
          <md-card>
            <md-card-header>
              <div class="md-title">CURP/RFC Existente</div>
            </md-card-header>
            <md-card-content>
              <div class="row">
                <div class="col-md-10">
                  <md-field>
                    <label>CURP/RFC</label>
                    <md-input v-model="curp" v-on:keyup.enter="getInfo(2)"/>
                  </md-field>
                </div>
                <div class="col-md-2">
                  <md-progress-spinner v-if="loading2" :md-diameter="30" :md-stroke="3" md-mode="indeterminate"/>
                  <md-button v-else class="md-raised md-primary" @click="getInfo(2)" :disabled="curp===null">
                    Buscar
                  </md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-6">
          <div class="md-title" v-if="pp1!=null&&pp2!=null">Acción:
            <div v-if="pp1.id !== pp2.id" style="margin-top: -30px;margin-bottom: 40px">
              <md-button class="md-raised md-primary" @click="setCURP()" style="float: right" :disabled="setting" v-if="curprfc==='curp'">
                Asignar CURP {{pp2.curp}} al Nuevo Usuario
              </md-button>
              <md-button class="md-raised md-primary" @click="setCURP()" style="float: right" :disabled="setting" v-else>
                Asignar RFC {{pp2.rfc}} al Nuevo Usuario
              </md-button>
            </div>
            <div v-else style="margin-top: -30px;margin-bottom: 30px">
              <span style="color: red; float: right">Mismo perfil</span>
            </div>
          </div>
          <br>
          <expediente :loading="loading1"
                      :tipousuario="tipousuario1"
                      :tipopersona="tipopersona1"
                      :pp="pp1"
                      :transacciones="transacciones1"
                      :userid="userid1"
                      :email="email1"
                      :acceso="acceso1"
                      :login="login1"
                      :mfa="mfa1"></expediente>
        </div>
        <div class="col-md-6">
          <div class="md-title" v-if="pp1!=null&&pp2!=null">Acción:
            <div v-if="pp1.id !== pp2.id" style="margin-top: -30px;margin-bottom: 40px">
              <md-button class="md-raised md-primary" @click="setPPID()" style="float: right" :disabled="setting">
                Asignar PPID {{pp2.id}} al Nuevo Usuario
              </md-button>
            </div>
            <div v-else style="margin-top: -30px;margin-bottom: 30px">
              <span style="color: red; float: right">Mismo perfil</span>
            </div>
          </div>
          <br>
          <expediente :loading="loading2"
                      :tipousuario="tipousuario2"
                      :tipopersona="tipopersona2"
                      :pp="pp2"
                      :transacciones="transacciones2"
                      :userid="userid2"
                      :email="email2"
                      :acceso="acceso2"
                      :login="login2"
                      :mfa="mfa2"></expediente>
        </div>
      </div>
    </div>
  </div>

</template>

<script lang="js">
  import * as moment from "moment";
  let Expediente = require('./Expediente').default;
  export default  {
    name: 'src-views-admin-curp-verification',
    filters: {
      human_date(date) {
        return date == null ? '' : moment(date).lang("es").format("DD MMM YYYY");
      }
    },
    components: {
      'expediente': Expediente,
    },
    mounted() {

    },
    data() {
      return {
        setting: false,
        emailOrUID: null,
        curp: null,
        pp1: null,
        pp2: null,
        tipousuario1: '----',
        tipopersona1: '----',
        tipousuario2: '----',
        tipopersona2: '----',
        loading1: false,
        loading2: false,
        userid1: null,
        userid2: null,
        email1: null,
        email2: null,
        transacciones1: null,
        transacciones2: null,
        acceso1: null,
        login1: null,
        acceso2: null,
        login2: null,
        mfa1: '----',
        mfa2: '----',
        curprfc: null
      }
    },
    methods: {
      getInfo(who){
        if(who === 1) {
          this.loading1 = true;
          this.pp1 = null;
          this.tipousuario1 = '----';
          this.tipopersona1 = '----';
          this.mfa1 = '----';
          this.transacciones1 = 0;
          axios.post( '/api/clients-control/curp-verification/pp/get', {
            'emailOrUID': this.emailOrUID
          }).then((resolve) => {
            this.pp1 = resolve.data.pp;
            this.tipousuario1 = resolve.data.tipousuario;
            this.tipopersona1 = resolve.data.tipopersona;
            this.userid1 = resolve.data.user_id;
            this.email1 = resolve.data.email;
            this.transacciones1 = resolve.data.transacciones;
            this.acceso1 = resolve.data.acceso;
            this.login1 = resolve.data.login;
            this.mfa1 = resolve.data.mfa;
            this.loading1 = false;
          });
        } else {
          this.loading2 = true;
          this.pp2 = null;
          this.tipousuario2 = '----';
          this.tipopersona2 = '----';
          this.mfa2 = '----';
          this.transacciones2 = 0;
          axios.post( '/api/clients-control/curp-verification/pp/get', {
            'curp': this.curp
          }).then((resolve) => {
            this.pp2 = resolve.data.pp;
            this.tipousuario2 = resolve.data.tipousuario;
            this.tipopersona2 = resolve.data.tipopersona;
            this.userid2 = resolve.data.user_id;
            this.email2 = resolve.data.email;
            this.transacciones2 = resolve.data.transacciones;
            this.acceso2 = resolve.data.acceso;
            this.login2 = resolve.data.login;
            this.mfa2 = resolve.data.mfa;
            this.curprfc = resolve.data.curprfc
            this.loading2 = false;
          });
        }
      },
      setCURP(){
        this.setting = true;
        axios.post( '/api/clients-control/curp-verification/pp/curp', {
          'pp1': this.pp1.id,
          'pp2': this.pp2.id,
          'curprfc': this.curprfc
        }).then((resolve) => {
          this.setting = false;
          this.getInfo(1);
          this.getInfo(2);
        });
      },
      setPPID(){
        this.setting = true;
        axios.post( '/api/clients-control/curp-verification/pp/id', {
          'pp2': this.pp2.id,
          'userid': this.userid1,
        }).then((resolve) => {
          this.setting = false;
          this.getInfo(1);
          this.getInfo(2);
        });
      },
    },
    computed: {

    }
}
</script>

